import get from 'lodash/get';
import { countryCodes } from '../../constants/locale';

export default function getCountryCode(state) {
  return get(state.config, ['location', 'country_code'], countryCodes.US);
}
